
import { mapState, mapActions } from 'vuex';
import env from '@/.env.json';
import Button from '@/components/elements/Button';
import CustomModal from '@/components/elements/CustomModal';
import CustomInput from '~/components/elements/CustomInput';
import CustomCheck from '~/components/elements/CustomCheck.vue';
import LoaderDots from '~/components/elements/LoaderDots';

export default {
  name: 'AuthModal',
  components: {
    CustomModal,
    CustomInput,
    CustomCheck,
    Button,
    LoaderDots,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    offerId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      termsAgree: false,
      loading: false,
      errorMessage: '',
      success: false,
      errors: {
        name: false,
        phone: false,
        email: false,
      },
      privacyPolicyLink: env.PRIVACY_POLICY,
      privacyPolicyConsentLink: env.PRIVACY_POLICY_CONSENT,
      publicOffer: env.PUBLIC_OFFER,
    };
  },
  computed: {
    ...mapState('profile', ['profile']),
  },
  async mounted() {
    if (!this.profile) {
      await this.loadProfile()
    }

    const firstName = this.profile?.first_name ? this.profile.first_name : '';
    const lastName = this.profile?.last_name ? this.profile.last_name : '';
    this.name = `${firstName} ${lastName}`;

    this.phone = this.profile?.phone;
    this.email = this.profile?.email;
  },
  methods: {
    ...mapActions({
      loadProfile: 'profile/loadProfile',
    }),
    closeModal() {
      this.$emit('close')
    },
    async onSubmit() {
      this.errors.name = !this.name;
      this.errors.phone = !this.phone;
      this.errors.email = !this.email;

      if (this.errors.name || this.errors.phone || this.errors.email) {
        return;
      }

      try {
        this.loading = true;
        await this.$axios.post('/v1/checkout/preorder', {
          offer_id: this.offerId,
          name: this.name,
          phone: this.phone,
          email: this.email,
        });
        this.errorMessage = '';
        this.success = true;
      } catch (error) {
        this.errorMessage = error.response?.data?.message || 'Ошибка при отправке данных';
      } finally {
        this.loading = false;
      }
    },
  },
};
